import { createQueryParams } from '../../utils/Function/commonFunction';
import axiosBasicInstance from '../axiosConfig';

const getShiftListAll = async (langId) => {
   try {
      const response = await axiosBasicInstance.get(`/management/shift?${createQueryParams({ page: 1, record: 500, })}`, {
         headers: {
            langId
         },
      });

      return response;
   } catch (error) {
      throw error;
   }
};

const getShiftListAllHaveAllShift = async () => {
   try {
      const response = await axiosBasicInstance.get(
         `/management/shift/all?${createQueryParams({
            page: 1,
            record: 500,
         })}`
      );
      return response;
   } catch (error) {
      throw error;
   }
};

const addShift = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/shift/add-shift', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const editShift = async (data) => {
   try {
      const response = await axiosBasicInstance.put('/management/shift/update-shift', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const deleteShift = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/shift/delete-shift', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getShiftByUser = async (data) => {
   try {
      const response = await axiosBasicInstance.post(
         '/management/shift/shift-by-user',
         data,
         {
            headers: {
               'Content-Type': 'application/json', // ⭐ BẮT BUỘC
            },
         }
      );
      return response;
   } catch (error) {
      throw error;
   }
};

const addRequestSwap = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/shift/request-swap',
         data,
      );
      return response;
   } catch (error) {
      throw error;
   }
}

const updateRequestSwap = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/shift/update-request-swap',
         data,
      );
      return response;
   } catch (error) {
      throw error;
   }
}

const exportShiftCSV = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/shift/export-shift', data, {
         responseType: 'blob',
      });
      return response;
   } catch (error) {
      throw error;
   }
};

export { addShift, editShift, getShiftListAll, getShiftListAllHaveAllShift, deleteShift, getShiftByUser, addRequestSwap, updateRequestSwap, exportShiftCSV };
